export default {
  status: {
    pending: 'Waiting for DNS',
    verified: 'Live',
    failed: 'Action needed',
  },
  summary: {
    preparing:
      'The records for {{host}} are being prepared. They appear here within about 15 minutes — or at once after pressing Check again.',
    pending:
      'Waiting for the DNS records below. This usually takes a few minutes and can take up to 48 hours — we keep checking on our own.',
    certificate_pending:
      'The records are in place. The certificate for {{host}} is being issued — this usually takes a few minutes.',
    verified: 'The online shop is live on {{host}}.',
    serving: 'The online shop is live on {{serving_host}}, but {{host}} itself does not open it yet.',
    apex_elsewhere:
      'The A record on @ does not point to the shop yet. If {{host}} shows a website that should stay there, leave @ as it is — the shop works on {{serving_host}}. Otherwise add the A record below.',
    apex_held:
      '{{host}} is used by another website on Vercel. For {{host}} to open the shop too, remove the domain from that website first.',
    regressed:
      '{{host}} worked before, but a record below stopped checking out. Fix it at the DNS provider, then press Check again.',
    record_elsewhere:
      'A record below points somewhere else. Change it at the DNS provider to the value shown, then press Check again.',
    records_missing:
      'The records below still cannot be found after 48 hours. Check that they were saved for {{zone}}, at the provider that manages its DNS. If that provider does not allow the change, the domain may be locked there.',
    certificate: {
      ownership_proof_required:
        '{{host}} is also connected to another Vercel account, so the restaurant has to prove the domain is its own.',
      held_by_another_project: '{{host}} is still used by another website on Vercel, so the shop cannot use it yet.',
      dns_correct_but_unconfigured: 'The records are right, but something else on {{host}} blocks the certificate.',
      name_mismatch: '{{host}} still answers with a certificate for another name.',
      expired: 'The certificate for {{host}} has expired. We have been alerted and are on it.',
      expiring: 'The certificate for {{host}} expires soon and has not been renewed yet. We are on it.',
      attach_refused: 'Our hosting provider refused to add {{host}} on our side. We have been alerted and are on it.',
      overdue: 'The certificate for {{host}} has still not been issued after 48 hours.',
      unknown: 'The certificate for {{host}} could not be issued.',
    },
    certificate_see_row: 'The certificate row below says what to do.',
  },
  instructions: {
    title: 'How to connect {{host}}',
    step_provider: 'Sign in where the DNS of {{zone}} is managed — usually the company the domain was bought from.',
    step_add: 'Add each record below exactly as shown: its type, its name and its value.',
    step_check: 'Save, then press {{button}}. We also keep checking on our own.',
    tip_name:
      'Most providers want only the part before {{zone}} in the name field — here {{names}}. The full name is shown too, for providers that ask for it.',
    tip_apex: '@ stands for {{zone}} itself. Some providers leave the name empty for it instead.',
    tip_apex_website:
      'If {{zone}} already opens a website, pointing @ at the shop moves {{zone}} away from that website. To keep the website there, leave the records on @ as they are — the shop still works on www.{{zone}} — or connect a subdomain such as order.{{zone}} for the shop instead.',
    tip_existing:
      'Remove any other A, AAAA or CNAME record on {{name}}. Two records pointing to different places make the shop load only some of the time.',
    tip_cloudflare:
      'On Cloudflare, set these records to DNS only (grey cloud). With the proxy on, nobody can see where they point, and no certificate can be issued.',
    tip_locked:
      'If the provider does not allow adding or changing these records, the domain may be locked, or its DNS may be managed somewhere else. The provider can unlock it or say where its DNS is managed.',
  },
  records: {
    title: 'Records for {{host}}',
  },
  separate_domains: {
    apex: 'This domain is for the online shop only: the shop takes {{zone}} and www.{{zone}}. A website needs another name — a subdomain of {{zone}}, or a domain of its own.',
    subdomain: 'This domain is for the online shop only. A website can use {{zone}} or www.{{zone}}.',
  },
  load_error: 'Could not load the domain status.',
  no_access: 'No access to the domain status of this restaurant.',
  polling_stopped: 'This page stopped refreshing on its own. Press Check again to refresh it.',
  buttons: {
    check_again: 'Check again',
    retry: 'Try again',
  },
  toasts: {
    check_started: 'Checking the records. This can take a minute.',
    check_failed: 'Could not start the check. Please try again.',
    check_too_soon: 'Checked just now. Please wait a minute before checking again.',
  },
};
